import { create } from 'zustand';
import { sortCompaniesByNumericId } from '@/lib/listOrdering';

type User = {
  admin_id: number;
  email: string;
  empId: string;
  empName: string;
  userProfile: any;
  roles?: string[];
  permissions?: string[];
  accessibleTabs?: string[];
  assumed_user_id?: number | null;
};

export type Company = {
  company_id: number;
  company_name: string;
  domain: string;
};

type AuthState = {
  user: User | null;
  company: Company | null;
  companies: Company[];
  loading: boolean;
  setUser: (user: User) => void;
  setCompany: (company: Company) => void;
  setCompanies: (companies: Company[]) => void;
  setLoading: (loading: boolean) => void;
};

export const authStore = create<AuthState>((set) => ({
  user: null,
  company: null,
  companies: [],
  loading: true,
  setUser: (user) => set({ user }),
  setCompany: (company) => set({ company }),
  setCompanies: (companies) =>
    set({ companies: sortCompaniesByNumericId(companies) }),
  setLoading: (loading) => set({ loading }),
}));
